module.exports = __webpack_public_path__ + "assets/f651f6a04f928800ee8ea90d0bd8e32e.jpg";